module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading_chord) ? _c('div', {
    staticClass: "animate-pulse"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : (!_vm.loading_chord && !_vm.show_empty_message) ? _c('div', {
    staticClass: "flex justify-center"
  }, [_c('ChordDiagram', {
    attrs: {
      "summary": _vm.summary
    },
    on: {
      "showEmptyMessage": function($event) {
        _vm.show_empty_message = true
      }
    }
  })], 1) : _c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "empty-message-size",
    attrs: {
      "src": "/static/D3ChordEmpty.png"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/5 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/12 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/6 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5e4b8478!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/summaryComponents/CommentChord.vue
// module id = 1163
// module chunks = 61